export function getStringFromJSX(text: string | JSX.Element) {
  return (typeof text === 'object' ? text.props.children : text) as string
}
